(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abz_box_bundel_banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const cards = document.querySelectorAll(".box-bundle-card");
  const buttons = document.querySelectorAll(".box-bundle-btn");
  const selectBox = document.getElementById("box-select");

  if (!cards.length) return;

  const sizeToIndex = { "2": 0, "4": 1, "6": 2 };
  const indexToSize = ["2", "4", "6"];

  function updateSelection(selectedIndex) {
    cards.forEach((card, idx) => {
      const btn = card.querySelector(".box-bundle-btn");
      const defaultLabel = btn.getAttribute("data-default-label");
      const selectedLabel = btn.getAttribute("data-selected-label");

      if (idx === selectedIndex) {
        card.classList.add("is-selected");
        btn.textContent = selectedLabel && selectedLabel.trim() !== "" ? selectedLabel : defaultLabel;
      } else {
        card.classList.remove("is-selected");
        btn.textContent = defaultLabel;
      }
    });

    localStorage.setItem("selectedBoxIndex", selectedIndex);

    if (selectBox && indexToSize[selectedIndex]) {
      selectBox.value = indexToSize[selectedIndex];
      localStorage.setItem("selectedBoxSize", selectBox.value);
    }
  }

  // 🔹 Expose global sync function (drawer will call this)
  window.syncBannerSelection = function(value) {
    const index = sizeToIndex[value];
    if (index !== undefined && cards[index]) {
      updateSelection(index);
    }
  };

  // 🔹 Setup button labels
  buttons.forEach((btn) => {
    btn.setAttribute("data-default-label", btn.textContent.trim());
    btn.setAttribute("data-selected-label", btn.getAttribute("data-selected-button-label") || "");
  });

  // 🔹 Initial load
  let initialIndex = null;
  const savedIndex = localStorage.getItem("selectedBoxIndex");
  if (savedIndex !== null && cards[savedIndex]) {
    initialIndex = parseInt(savedIndex);
  } else {
    initialIndex = Math.floor(cards.length / 2);
  }
  updateSelection(initialIndex);

  // 🔹 Button click
  buttons.forEach((btn, index) => {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      updateSelection(index);
    });
  });

  // 🔹 Drawer select → banner sync
  if (selectBox) {
    selectBox.addEventListener("change", function() {
      syncBannerSelection(this.value);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
